import { Box, Button, styled } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import { withFormController } from '../../../hocs/forms';
import { TextFieldBase } from '../../../inputs/TextFieldBase';

type TextFieldBaseProps = {
  containerClass?: string;
  label?: string;
  error?: string;
  showErrorPlace?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  required?: boolean;
  show?: boolean;
  showErrorMessage?: boolean;
} & TextFieldProps;

export const StyledLoginButton = styled(Button)(({ theme }) => {
  return {
    color: theme.config.colors.white,
    border: `1px solid ${theme.config.colors.white}`,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.config.colors.white,
      color: theme.config.colors.black,
    },
  };
});

export const StyledLink = styled(Box)(({ theme }) => {
  return {
    color: theme.config.colors.white,
    textDecoration: 'underline',
    cursor: 'pointer',
  };
});

const EmailBase = withFormController(TextFieldBase);
export const EmailField = (props: TextFieldBaseProps) => {
  return (
    <EmailBase
      name="username"
      placeholder="Please enter email"
      type="email"
      {...props}
    />
  );
};
